import React, { useState } from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import { Colors } from "../components/styles/Colors";
import { Body, Header4Styles } from "../components/typography";
import Img from "gatsby-image";
import richText from "../utils/richText";
import Breakpoints from "../components/styles/Breakpoints";
import IngredientsModal from "../components/IngredientsModal";
import ProductSubscriptionRadio from "../components/ProductSubscriptionRadio";

const Wrapper = styled.section`
  > .gatsby-image-wrapper {
    height: 450px;
  }

  > div:last-child {
    padding: 64px 32px;
    background: ${Colors.hunter};
    color: ${Colors.cream2};
  }

  @media ${Breakpoints.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 800px;

    > div {
      flex: 0 0 50%;
    }

    > .gatsby-image-wrapper {
      height: 100%;
    }

    > div:last-child {
      padding: 50px;
      box-sizing: border-box;

      > * {
        max-width: 480px;
      }
    }
  }

  @media ${Breakpoints.desktop} {
    > div:last-child {
      padding: 150px;
    }
  }
`;

const AccordionSection = styled.div`
  padding: 16px 0;

  border-bottom: 1px solid ${Colors.hunter};

  &:last-of-type {
    border-bottom: 0;
  }

  > ${Body} {
    display: block;
    margin-top: 24px;

    p ~ p {
      margin-top: 15px;
    }
  }
`;

const AccordionHeader = styled.button`
  ${Header4Styles}

  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  padding: 0;

  outline: none;

  color: ${Colors.lightBlue};

  background: 0;
  border: 0;
`;

export default function BundleIngredients({ data }) {
  const { groupSwatch, variants } = data;
  return (
    <Wrapper>
      <Img fluid={groupSwatch.fluid} backgroundColor="#E6E0D8" />
      <div>
        <DomeHeader text="The Products" centered light />
        {variants.map((v) => (
          <AccordionSection>
            <AccordionHeader>
              <span>{v.product.name}</span>
            </AccordionHeader>
            <Body>{v.product.shortDescription?.shortDescription}</Body>
            <IngredientsModal
              image={v.product.ingredientsImage.fluid}
              ingredients={v.product.ingredients}
            />
          </AccordionSection>
        ))}
      </div>
    </Wrapper>
  );
}
